const FUNCTION_AAA_ORCHESTRATORS_URL_HOST = process.env.REACT_APP_FUNCTION_URL;
const FUNCTION_AAA_ORCHESTRATORS_URL_CODE = process.env.REACT_APP_FUNCTION_AAA_ORCHESTRATORS_URL_CODE;

// Function to trigger the orchestrator
// This function will be called from the FileUpload.tsx
export async function triggerOrchestrators(orchesratorName: string, uniqueId, userEmail) {

    var orchestratorUrl = `${FUNCTION_AAA_ORCHESTRATORS_URL_HOST}/orchestrators/${orchesratorName}`;//?code=${FUNCTION_AAA_ORCHESTRATORS_URL_CODE}

    const response = await fetch(orchestratorUrl, {
        method: 'POST',
        mode: 'cors',
        headers: {
            "Content-Type": "application/json",
            "x-functions-key": `${FUNCTION_AAA_ORCHESTRATORS_URL_CODE}`
        },
        body: JSON.stringify({
            "directory": uniqueId,
            "email": userEmail
        })
    })
        .then((response) => {
            //console.log("Response", response);
            return response.json();
        })
        .then((data) => {
            //console.log("Data", data);
            return data.statusQueryGetUri;
        })
        .catch((error) => {
            console.error(error)
            alert('Error uploading :' + orchesratorName + '  ErrorMessage: ' + error);
        });

    return response;
}

// Function to trigger the orchestrator and get the response
// This function will be called from the FileUpload.tsx
export async function triggerOrchestratorsResponse(orchesratorResponse: string) {

    var response = "";
    // loop for 10 times to check the status of the orchestrator
    for (let i = 0; i < 10; i++) {

        response = await fetch(orchesratorResponse, {
            method: 'GET',
            mode: 'cors',
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((response) => {
                //console.log("Response", response);
                return response.json();
            })
            .then((data) => {
                //console.log("Data", data);
                // Check if the orchestrator is completed or not and return the status
                if (data.runtimeStatus === 'Completed') {
                    i = 10;
                    return data.runtimeStatus;
                }
                // Check if the orchestrator is running
                else if (data.runtimeStatus === 'Running' || data.runtimeStatus === 'Pending') {
                }
                // Check if the orchestrator is not completed and not running
                // then return the error
                else if (data.runtimeStatus === 'Failed' || data.runtimeStatus === 'Suspended' || data.runtimeStatus === 'Terminated') {
                    i = 10;
                    console.log("Error in orchestrator: ", data);
                    alert('Error in orchestrator: ' + data);
                    return data.runtimeStatus;
                }
            })
            .catch((error) => {
                i = 10;
                console.error(error)
                alert('ErrorMessage: ' + error);
            });

        if (response === 'Completed') {
            break;
        }
        //Wait for 5 seconds
        await new Promise(resolve => setTimeout(resolve, 5000));
    }

    return response;
}
